













































import Vue from "vue";
export default Vue.extend({
  name: "LoginDialog",
  data: () => ({
    show: false,
    username: null,
    password: null,
    loading: false,
    error: false,
  }),
  methods: {
    async login () {
      this.loading = true;
      this.error = false;
      try {
        const response = await this.axios.post(
          Vue.axios.defaults.baseURL + "/users/sessions",
          {
            username: this.username,
            password: this.password,
          }
        );

        this.$emit("close", response.data);
        this.username = null;
        this.password = null;
      } catch (error) {
        this.error = true;
      }
      this.loading = false;
    },
  },
});
